<mat-list *ngIf="projectUi$ | async as projectUi">
  <mat-list-item>

    <div mat-list-icon [ngSwitch]="projectUi.centralOffices.length">

      <mat-icon *ngSwitchCase="0">fiber_manual_record</mat-icon>

      <ng-container *ngSwitchCase="1">
        <mat-icon class="icon-action" *ngIf="projectUi.centralOfficeConnectedToBox"
          (click)="flyToVertex(projectUi.centralOffices)">
          check_circle</mat-icon>
        <mat-error *ngIf="!projectUi.centralOfficeConnectedToBox" i18n-matTooltip
          matTooltip="Must be connected to a underground box" (click)="flyToVertex(projectUi.centralOffices)">
          <mat-icon class="icon-action">error</mat-icon>
        </mat-error>
      </ng-container>

      <mat-error *ngSwitchDefault i18n-matTooltip matTooltip="Must be only one"
        (click)="flyToVertex(projectUi.centralOffices)">
        <mat-icon class="icon-action">error</mat-icon>
      </mat-error>

    </div>
    <div mat-line i18n>Central Office</div>
  </mat-list-item>

  <mat-list-item>

    <mat-error mat-list-icon i18n-matTooltip matTooltip="All must be connected to central office"
      *ngIf="vertexesInvalid.length" (click)="flyToVertex(vertexesInvalid)">
      <mat-icon class="icon-action">error</mat-icon>
    </mat-error>

    <mat-icon mat-list-icon *ngIf="!vertexesInvalid.length && !projectUi.hasVertexes">fiber_manual_record</mat-icon>
    <mat-icon mat-list-icon
      *ngIf="!vertexesInvalid.length && projectUi.hasVertexes && projectUi.vertexesWithoutEdges.length === 0">
      check_circle
    </mat-icon>

    <mat-error mat-list-icon
      *ngIf="!vertexesInvalid.length && projectUi.hasVertexes && projectUi.vertexesWithoutEdges.length > 0"
      i18n-matTooltip matTooltip="All must be connected to another vertex"
      (click)="flyToVertex(projectUi.vertexesWithoutEdges)">
      <mat-icon class="icon-action">error</mat-icon>
    </mat-error>

    <div mat-line i18n>Vertex</div>
  </mat-list-item>

  <mat-list-item>
    <mat-icon mat-list-icon *ngIf="!projectUi.hasEdges">fiber_manual_record</mat-icon>
    <mat-icon mat-list-icon *ngIf="projectUi.hasEdges">check_circle</mat-icon>

    <div mat-line i18n>Edge</div>
  </mat-list-item>

  <mat-list-item>
    <mat-icon mat-list-icon *ngIf="!projectUi.hasBuilding">fiber_manual_record</mat-icon>
    <mat-icon class="icon-action" mat-list-icon
      *ngIf="projectUi.hasBuilding && projectUi.disconnectedBuildings.length >= 1" i18n-matTooltip
      matTooltip="Has disconnected building" (click)="flyToBuilding(projectUi.disconnectedBuildings)">warning
    </mat-icon>
    <mat-icon mat-list-icon *ngIf="projectUi.hasBuilding && projectUi.disconnectedBuildings.length == 0">check_circle
    </mat-icon>

    <div mat-line i18n>Building</div>
  </mat-list-item>

</mat-list>
